// Sample random data
export const fixtureData = [
    {
        stock: 'SID capital',
        current: 132.97259159928635,
        time: '2023-02-02T12:00:30.486Z',
        timeline: [
            {
                value: 68.45605159378691,
                time: '2023-02-02T12:00:10.486Z',
            },
            {
                value: 110.9428376507644,
                time: '2023-02-02T12:00:11.486Z',
            },
            {
                value: 135.76172912874802,
                time: '2023-02-02T12:00:12.486Z',
            },
            {
                value: 6.299423808999061,
                time: '2023-02-02T12:00:13.486Z',
            },
            {
                value: 58.60395199619004,
                time: '2023-02-02T12:00:14.486Z',
            },
            {
                value: 31.461459826201622,
                time: '2023-02-02T12:00:15.486Z',
            },
            {
                value: 78.0081122596089,
                time: '2023-02-02T12:00:16.486Z',
            },
            {
                value: 80.2406111999634,
                time: '2023-02-02T12:00:17.486Z',
            },
            {
                value: 99.2773647936094,
                time: '2023-02-02T12:00:18.486Z',
            },
            {
                value: 148.47728961449147,
                time: '2023-02-02T12:00:19.486Z',
            },
            {
                value: 24.50275704132514,
                time: '2023-02-02T12:00:20.486Z',
            },
            {
                value: 97.1480985275057,
                time: '2023-02-02T12:00:21.486Z',
            },
            {
                value: 114.65784271948887,
                time: '2023-02-02T12:00:22.486Z',
            },
            {
                value: 86.53001118069017,
                time: '2023-02-02T12:00:23.486Z',
            },
            {
                value: 43.05342613766716,
                time: '2023-02-02T12:00:24.486Z',
            },
            {
                value: 27.321015982773332,
                time: '2023-02-02T12:00:25.486Z',
            },
            {
                value: 43.27351176197038,
                time: '2023-02-02T12:00:26.486Z',
            },
            {
                value: 41.813477139217184,
                time: '2023-02-02T12:00:27.486Z',
            },
            {
                value: 8.090812197045894,
                time: '2023-02-02T12:00:28.486Z',
            },
            {
                value: 132.97259159928635,
                time: '2023-02-02T12:00:30.486Z',
            },
        ],
    },
    {
        stock: 'Uptick 500',
        current: 31.306198239258197,
        time: '2023-02-02T12:00:30.486Z',
        timeline: [
            {
                value: 102.85485846695671,
                time: '2023-02-02T12:00:10.486Z',
            },
            {
                value: 72.67826024411823,
                time: '2023-02-02T12:00:11.486Z',
            },
            {
                value: 60.58862876878768,
                time: '2023-02-02T12:00:12.486Z',
            },
            {
                value: 71.16199821097715,
                time: '2023-02-02T12:00:13.486Z',
            },
            {
                value: 130.02444086492477,
                time: '2023-02-02T12:00:14.486Z',
            },
            {
                value: 122.33380891799592,
                time: '2023-02-02T12:00:15.486Z',
            },
            {
                value: 105.40923616636778,
                time: '2023-02-02T12:00:16.486Z',
            },
            {
                value: 122.9788130251037,
                time: '2023-02-02T12:00:17.486Z',
            },
            {
                value: 117.74183513782269,
                time: '2023-02-02T12:00:18.486Z',
            },
            {
                value: 93.72738945995866,
                time: '2023-02-02T12:00:19.486Z',
            },
            {
                value: 16.885512403691017,
                time: '2023-02-02T12:00:20.486Z',
            },
            {
                value: 57.543376908011844,
                time: '2023-02-02T12:00:21.486Z',
            },
            {
                value: 81.15275421124986,
                time: '2023-02-02T12:00:22.486Z',
            },
            {
                value: 46.63768982348674,
                time: '2023-02-02T12:00:23.486Z',
            },
            {
                value: 79.43262326536461,
                time: '2023-02-02T12:00:24.486Z',
            },
            {
                value: 72.48538795914556,
                time: '2023-02-02T12:00:25.486Z',
            },
            {
                value: 46.44213975899717,
                time: '2023-02-02T12:00:26.486Z',
            },
            {
                value: 18.933804285895217,
                time: '2023-02-02T12:00:27.486Z',
            },
            {
                value: 50.386444869774806,
                time: '2023-02-02T12:00:28.486Z',
            },
            {
                value: 31.306198239258197,
                time: '2023-02-02T12:00:30.486Z',
            },
        ],
    },
    {
        stock: 'Xingyun BA',
        current: 11.661330682053661,
        time: '2023-02-02T12:00:30.486Z',
        timeline: [
            {
                value: 69.3285352450902,
                time: '2023-02-02T12:00:10.486Z',
            },
            {
                value: 95.83038880159965,
                time: '2023-02-02T12:00:11.486Z',
            },
            {
                value: 52.10354718374133,
                time: '2023-02-02T12:00:12.486Z',
            },
            {
                value: 30.582364973449206,
                time: '2023-02-02T12:00:13.486Z',
            },
            {
                value: 7.530988009864492,
                time: '2023-02-02T12:00:14.486Z',
            },
            {
                value: 80.72572396007119,
                time: '2023-02-02T12:00:15.486Z',
            },
            {
                value: 74.35553641823024,
                time: '2023-02-02T12:00:16.486Z',
            },
            {
                value: 78.88318497073922,
                time: '2023-02-02T12:00:17.486Z',
            },
            {
                value: 55.55914611887084,
                time: '2023-02-02T12:00:18.486Z',
            },
            {
                value: 39.509039031435854,
                time: '2023-02-02T12:00:19.486Z',
            },
            {
                value: 78.48886719175513,
                time: '2023-02-02T12:00:20.486Z',
            },
            {
                value: 73.41105461677851,
                time: '2023-02-02T12:00:21.486Z',
            },
            {
                value: 86.39730372046317,
                time: '2023-02-02T12:00:22.486Z',
            },
            {
                value: 13.250505411002756,
                time: '2023-02-02T12:00:23.486Z',
            },
            {
                value: 83.16444810532504,
                time: '2023-02-02T12:00:24.486Z',
            },
            {
                value: 29.09883262047951,
                time: '2023-02-02T12:00:25.486Z',
            },
            {
                value: 103.71880624005894,
                time: '2023-02-02T12:00:26.486Z',
            },
            {
                value: 149.00825313952288,
                time: '2023-02-02T12:00:27.486Z',
            },
            {
                value: 41.095394555099396,
                time: '2023-02-02T12:00:28.486Z',
            },
            {
                value: 11.661330682053661,
                time: '2023-02-02T12:00:30.486Z',
            },
        ],
    },
    {
        stock: 'Wiltshire 4500-kbm',
        current: 36.398157927763904,
        time: '2023-02-02T12:00:30.486Z',
        timeline: [
            {
                value: 119.01223718630519,
                time: '2023-02-02T12:00:10.486Z',
            },
            {
                value: 98.76566586665203,
                time: '2023-02-02T12:00:11.486Z',
            },
            {
                value: 109.80995620926656,
                time: '2023-02-02T12:00:12.486Z',
            },
            {
                value: 46.260101144210076,
                time: '2023-02-02T12:00:13.486Z',
            },
            {
                value: 122.37183711909367,
                time: '2023-02-02T12:00:14.486Z',
            },
            {
                value: 89.18225211919247,
                time: '2023-02-02T12:00:15.486Z',
            },
            {
                value: 76.61132437568287,
                time: '2023-02-02T12:00:16.486Z',
            },
            {
                value: 8.464445148697465,
                time: '2023-02-02T12:00:17.486Z',
            },
            {
                value: 5.275592613195967,
                time: '2023-02-02T12:00:18.486Z',
            },
            {
                value: 65.90837475625382,
                time: '2023-02-02T12:00:19.486Z',
            },
            {
                value: 134.18397208302702,
                time: '2023-02-02T12:00:20.486Z',
            },
            {
                value: 90.90206723318838,
                time: '2023-02-02T12:00:21.486Z',
            },
            {
                value: 15.835947902601266,
                time: '2023-02-02T12:00:22.486Z',
            },
            {
                value: 30.2476770054287,
                time: '2023-02-02T12:00:23.486Z',
            },
            {
                value: 51.359859056230015,
                time: '2023-02-02T12:00:24.486Z',
            },
            {
                value: 78.63862901364801,
                time: '2023-02-02T12:00:25.486Z',
            },
            {
                value: 9.380002429101687,
                time: '2023-02-02T12:00:26.486Z',
            },
            {
                value: 127.7849310169981,
                time: '2023-02-02T12:00:27.486Z',
            },
            {
                value: 76.06562905287791,
                time: '2023-02-02T12:00:28.486Z',
            },
            {
                value: 36.398157927763904,
                time: '2023-02-02T12:00:30.486Z',
            },
        ],
    },
    {
        stock: 'DT PI',
        current: 113.41761236597738,
        time: '2023-02-02T12:00:30.486Z',
        timeline: [
            {
                value: 48.78017439075346,
                time: '2023-02-02T12:00:10.486Z',
            },
            {
                value: 142.13087038984185,
                time: '2023-02-02T12:00:11.486Z',
            },
            {
                value: 103.37560896786052,
                time: '2023-02-02T12:00:12.486Z',
            },
            {
                value: 9.783541944889574,
                time: '2023-02-02T12:00:13.486Z',
            },
            {
                value: 29.836545666130597,
                time: '2023-02-02T12:00:14.486Z',
            },
            {
                value: 92.22653651953064,
                time: '2023-02-02T12:00:15.486Z',
            },
            {
                value: 33.38129982298443,
                time: '2023-02-02T12:00:16.486Z',
            },
            {
                value: 39.894656199037804,
                time: '2023-02-02T12:00:17.486Z',
            },
            {
                value: 66.26948215755337,
                time: '2023-02-02T12:00:18.486Z',
            },
            {
                value: 51.72453093950252,
                time: '2023-02-02T12:00:19.486Z',
            },
            {
                value: 21.848774800673397,
                time: '2023-02-02T12:00:20.486Z',
            },
            {
                value: 25.07322447647433,
                time: '2023-02-02T12:00:21.486Z',
            },
            {
                value: 138.72431315909003,
                time: '2023-02-02T12:00:22.486Z',
            },
            {
                value: 8.84084318180074,
                time: '2023-02-02T12:00:23.486Z',
            },
            {
                value: 133.55793357963788,
                time: '2023-02-02T12:00:24.486Z',
            },
            {
                value: 97.62309713840688,
                time: '2023-02-02T12:00:25.486Z',
            },
            {
                value: 107.52164034113098,
                time: '2023-02-02T12:00:26.486Z',
            },
            {
                value: 39.046710618741656,
                time: '2023-02-02T12:00:27.486Z',
            },
            {
                value: 60.76448987639318,
                time: '2023-02-02T12:00:28.486Z',
            },
            {
                value: 113.41761236597738,
                time: '2023-02-02T12:00:30.486Z',
            },
        ],
    },
    {
        stock: 'ESTA-MID',
        current: 146.7882491352121,
        time: '2023-02-02T12:00:30.486Z',
        timeline: [
            {
                value: 4.24163821530964,
                time: '2023-02-02T12:00:10.486Z',
            },
            {
                value: 140.93304368991855,
                time: '2023-02-02T12:00:11.486Z',
            },
            {
                value: 97.79592128664206,
                time: '2023-02-02T12:00:12.486Z',
            },
            {
                value: 65.64912392473936,
                time: '2023-02-02T12:00:13.486Z',
            },
            {
                value: 50.4327266836587,
                time: '2023-02-02T12:00:14.486Z',
            },
            {
                value: 56.18080752716828,
                time: '2023-02-02T12:00:15.486Z',
            },
            {
                value: 135.82690234071453,
                time: '2023-02-02T12:00:16.486Z',
            },
            {
                value: 116.82687694890956,
                time: '2023-02-02T12:00:17.486Z',
            },
            {
                value: 50.67528720144131,
                time: '2023-02-02T12:00:18.486Z',
            },
            {
                value: 20.039404032991015,
                time: '2023-02-02T12:00:19.486Z',
            },
            {
                value: 83.74460898149142,
                time: '2023-02-02T12:00:20.486Z',
            },
            {
                value: 120.70806717029977,
                time: '2023-02-02T12:00:21.486Z',
            },
            {
                value: 124.92049787142855,
                time: '2023-02-02T12:00:22.486Z',
            },
            {
                value: 136.2751892514669,
                time: '2023-02-02T12:00:23.486Z',
            },
            {
                value: 78.89787072946814,
                time: '2023-02-02T12:00:24.486Z',
            },
            {
                value: 75.89106445864833,
                time: '2023-02-02T12:00:25.486Z',
            },
            {
                value: 131.84364257351234,
                time: '2023-02-02T12:00:26.486Z',
            },
            {
                value: 125.76759537693754,
                time: '2023-02-02T12:00:27.486Z',
            },
            {
                value: 75.56751458760775,
                time: '2023-02-02T12:00:28.486Z',
            },
            {
                value: 146.7882491352121,
                time: '2023-02-02T12:00:30.486Z',
            },
        ],
    },
    {
        stock: 'Capra ibex',
        current: 18.030743900818457,
        time: '2023-02-02T12:00:30.486Z',
        timeline: [
            {
                value: 17.982253467997687,
                time: '2023-02-02T12:00:10.486Z',
            },
            {
                value: 55.29598059360878,
                time: '2023-02-02T12:00:11.486Z',
            },
            {
                value: 91.52040236174383,
                time: '2023-02-02T12:00:12.486Z',
            },
            {
                value: 35.315483680553584,
                time: '2023-02-02T12:00:13.486Z',
            },
            {
                value: 56.22984763554605,
                time: '2023-02-02T12:00:14.486Z',
            },
            {
                value: 12.366297188549913,
                time: '2023-02-02T12:00:15.486Z',
            },
            {
                value: 111.64097704895134,
                time: '2023-02-02T12:00:16.486Z',
            },
            {
                value: 13.072223812181527,
                time: '2023-02-02T12:00:17.486Z',
            },
            {
                value: 6.740974863670979,
                time: '2023-02-02T12:00:18.486Z',
            },
            {
                value: 101.94426813604919,
                time: '2023-02-02T12:00:19.486Z',
            },
            {
                value: 44.14733516599324,
                time: '2023-02-02T12:00:20.486Z',
            },
            {
                value: 122.19184419477595,
                time: '2023-02-02T12:00:21.486Z',
            },
            {
                value: 89.0426525016314,
                time: '2023-02-02T12:00:22.486Z',
            },
            {
                value: 140.21647555217106,
                time: '2023-02-02T12:00:23.486Z',
            },
            {
                value: 64.11264691173493,
                time: '2023-02-02T12:00:24.486Z',
            },
            {
                value: 145.73028943717557,
                time: '2023-02-02T12:00:25.486Z',
            },
            {
                value: 13.071576010483843,
                time: '2023-02-02T12:00:26.486Z',
            },
            {
                value: 141.3304231923853,
                time: '2023-02-02T12:00:27.486Z',
            },
            {
                value: 7.064651008260448,
                time: '2023-02-02T12:00:28.486Z',
            },
            {
                value: 18.030743900818457,
                time: '2023-02-02T12:00:30.486Z',
            },
        ],
    },
    {
        stock: 'NY composite index',
        current: 31.55602427773325,
        time: '2023-02-02T12:00:30.486Z',
        timeline: [
            {
                value: 23.308756067743197,
                time: '2023-02-02T12:00:10.486Z',
            },
            {
                value: 32.24033376466715,
                time: '2023-02-02T12:00:11.486Z',
            },
            {
                value: 0.7823121904950825,
                time: '2023-02-02T12:00:12.486Z',
            },
            {
                value: 25.901396926841013,
                time: '2023-02-02T12:00:13.486Z',
            },
            {
                value: 108.42459046401575,
                time: '2023-02-02T12:00:14.486Z',
            },
            {
                value: 51.30897332084262,
                time: '2023-02-02T12:00:15.486Z',
            },
            {
                value: 125.3530067014326,
                time: '2023-02-02T12:00:16.486Z',
            },
            {
                value: 16.086863240331915,
                time: '2023-02-02T12:00:17.486Z',
            },
            {
                value: 38.74140767308389,
                time: '2023-02-02T12:00:18.486Z',
            },
            {
                value: 104.14620476042062,
                time: '2023-02-02T12:00:19.486Z',
            },
            {
                value: 62.42990967627122,
                time: '2023-02-02T12:00:20.486Z',
            },
            {
                value: 71.63543040761282,
                time: '2023-02-02T12:00:21.486Z',
            },
            {
                value: 136.3249892643722,
                time: '2023-02-02T12:00:22.486Z',
            },
            {
                value: 104.17025930664578,
                time: '2023-02-02T12:00:23.486Z',
            },
            {
                value: 43.92172830970974,
                time: '2023-02-02T12:00:24.486Z',
            },
            {
                value: 127.00771344822817,
                time: '2023-02-02T12:00:25.486Z',
            },
            {
                value: 79.80911317345956,
                time: '2023-02-02T12:00:26.486Z',
            },
            {
                value: 43.01512420299868,
                time: '2023-02-02T12:00:27.486Z',
            },
            {
                value: 120.82568514706647,
                time: '2023-02-02T12:00:28.486Z',
            },
            {
                value: 31.55602427773325,
                time: '2023-02-02T12:00:30.486Z',
            },
        ],
    },
];
